import { rebuildChart } from "../components/chart";

(() => {
  if ("undefined" == typeof FEATURED_STAT) {
    return;
  }

  $(".btn-menu-stats").on("click", function () {
    let stat = $(this).attr("data-stat");
    activeStatsButton(stat);
  });

  const activeStatsButton = (stat) => {
    $(".btn-menu-stats").removeClass("active");
    $(`.btn-menu-stats[data-stat='${stat}']`).addClass("active");
    showStat(stat);
  };

  const showStat = (stat) => {
    $(".chart-stats-container").hide();
    $(`#chart-stats-${stat}-container`).show();

    rebuildChart(`chart-stats-${stat}`);
  };

  $(() => activeStatsButton(FEATURED_STAT));
})();
